import React from 'react';
import MasterAuthPage from '../masterAuthPage';

import {Formik} from 'formik'

import {
    TextField,
    Button,
    Box,
    Typography
} from '@mui/material';

import GoogleIcon from '@mui/icons-material/Google';

import { signInValidationSchema } from '../../services/schemas';
import { signInGoogleFirebase } from '../../redux/user/actions';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {signInFirebase} from '../../redux/user/actions'

export default function Login(){

    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <MasterAuthPage>
            <Typography
            variant='h3'
            color='primary'
            sx={{
                mb: 2,
            }}
            >
                Faça login
            </Typography>
            <Typography 
            variant='body2' 
            sx={{
                // my: 2,
                textAlign: 'left'
            }}>
                Não tem uma conta?
                <Typography 
                variant='span' 
                color='primary'
                onClick={()=>navigate("/signUp")}
                sx={{
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    '&:hover': {
                        opacity: 0.8
                    },
                    '&:active': {
                        opacity: 0.6
                    }
                }}
                > Criar agora</Typography>
            </Typography>

            <Formik
                    validationSchema={signInValidationSchema}
                    initialValues={{
                        email: '',
                        password: '',
                    }}
                    onSubmit={values => {dispatch(signInFirebase(values))}}
                >
                {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
                }) => (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                mt: 3,
                                
                                '& .MuiInputBase-root': {
                                    borderRadius: 5
                                },
                            }}
                        >
                            <TextField
                                label="E-mail"
                                type={'email'}
                                variant="outlined"
                                onBlur={handleBlur('email')}
                                value={values.email}
                                onChangeCapture={handleChange('email')}
                                error={errors.email && touched.email}
                                inputProps={{
                                    style: {
                                        color: 'black',
                                    }
                                }}
                                
                            />
                            {(errors.email && touched.email) &&
                            <Typography 
                            variant='p'
                            color='error'
                            sx={{
                                mt: 1,
                                textAlign: 'left'
                            }}>
                                {errors.email}
                            </Typography>
                            }
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                my: 2,
                                '& .MuiInputBase-root': {
                                    borderRadius: 5
                                },
                            }}
                        >
                            <TextField
                                label="Senha"
                                type={'password'}
                                variant="outlined"
                                onBlur={handleBlur('password')}
                                value={values.password}
                                onChangeCapture={handleChange('password')}
                                error={errors.password && touched.password}
                        
                                inputProps={{
                                    style: {
                                        color: 'black',
                                    },
                                }}
                                
                            />
                            {(errors.password && touched.password) &&
                            <Typography 
                            variant='p'
                            color='error'
                            sx={{
                                mt: 1,
                                textAlign: 'left'
                            }}>
                                {errors.password}
                            </Typography>
                            }
                        </Box>

                        <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'right',
                        }}>
                            <Typography 
                            variant='body2' 
                            color='primary.main'
                            onClick={()=>navigate("/recoverPassword")}
                            sx={{
                                mb: 2,
                                cursor: 'pointer',
                                '&:hover': {
                                    opacity: 0.8
                                },
                                '&:active': {
                                    opacity: 0.6
                                },
                                fontWeight: 'bold'
                            }}>
                                Quero refazer a senha
                            </Typography>

                            <Button
                            variant="contained"
                            color='primary'
                            className='btnLogin'
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                borderRadius: 3,
                            }}
                            onClick={handleSubmit}>
                                Entrar
                            </Button>

                            <Button
                            variant="contained"
                            color='secondary'
                            startIcon={<GoogleIcon/>}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold',
                                borderRadius: 3,
                                mt: 2
                            }}
                            onClick={()=>{
                                dispatch(signInGoogleFirebase())
                            }}>
                                Continue com o Google
                            </Button>

                        </Box>

                            
                    </>
                )}
                </Formik>
        </MasterAuthPage>
    )
}